<template>
  <Panel class="w-64">
    <template #header>
      <div
        class="flex grow justify-center"
        v-if="authStore.authenticated"
        data-test="header-authenticated"
      >
        <div v-if="initials && initials.length > 0">
          <div
            class="bg-gray-200 text-gray-700 text-6xl rounded-full w-24 h-24 leading-[96px] text-center"
            data-test="initials"
          >
            {{ initials }}
          </div>
        </div>
        <div v-else>
          <Skeleton
            width="96px"
            height="96px"
            class="rounded-full"
            data-test="initials-skeleton"
          />
        </div>
      </div>
    </template>
    <template #footer>
      <div
        class="flex flex-wrap items-center justify-between"
        v-if="authStore.authenticated"
        data-test="footer-authenticated"
      >
        <div>Not you?</div>
        <Button
          size="small"
          @click="authStore.logout(false)"
          data-test="logout-button"
          >Log Out</Button
        >
      </div>
      <div
        v-else
        data-test="footer-not-authenticated"
      >
        <div></div>
        <Button
          as="a"
          @click="authStore.redirectToTokenAuth()"
          size="small"
          data-test="login-button"
          >Log In</Button
        >
      </div>
    </template>
    <div class="flex flex-col items-center justify-center relative overflow-hidden text-center h-32">
      <div
        v-if="authStore.authenticated"
        data-test="authenticated-content"
      >
        <Transition name="appear">
          <div
            v-if="Object.keys(donorStore.donorInfo).length > 0"
            data-test="donor-info"
          >
            <p>Logged in as</p>
            <div
              class="text-lg font-bold"
              data-test="full-name"
            >
              {{ donorStore.donorInfo.firstName }} {{ donorStore.donorInfo.lastName }}
            </div>
            <div
              class="text-xs overflow-hidden text-ellipsis whitespace-nowrap w-48"
              data-test="email"
            >
              {{ donorStore.donorInfo.email }}
            </div>
          </div>
          <div
            v-else
            class="w-full"
            data-test="donor-info-skeleton"
          >
            <Skeleton
              height="1.5rem"
              class="mb-1"
            />
            <Skeleton
              height="1.75rem"
              class="mb-1"
            />
            <Skeleton height="1rem" />
          </div>
        </Transition>
      </div>
      <div
        v-else
        data-test="not-authenticated-content"
      >
        <p>Not logged in</p>
      </div>
    </div>
  </Panel>
</template>

<script setup>
import { computed, watch, onMounted } from 'vue';
import { useAuthStore } from '@/stores/AuthStore.js';
import { useDonorStore } from '@/stores/DonorStore.js';
import { Skeleton } from 'primevue';

const authStore = useAuthStore();
const donorStore = useDonorStore();

const initials = computed(() => {
  const initialsValue = donorStore.donorInfo.firstName
    ? (donorStore.donorInfo.firstName.charAt(0) + donorStore.donorInfo.lastName.charAt(0)).toUpperCase()
    : '';
  return initialsValue;
});
</script>
